"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DeleteObjectInput_1 = require("./DeleteObjectInput");
var DeleteObjectOutput_1 = require("./DeleteObjectOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.DeleteObject = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "DeleteObject",
    http: {
        method: "DELETE",
        requestUri: "/{Bucket}/{Key+}"
    },
    input: {
        shape: DeleteObjectInput_1.DeleteObjectInput
    },
    output: {
        shape: DeleteObjectOutput_1.DeleteObjectOutput
    },
    errors: []
};
//# sourceMappingURL=DeleteObject.js.map